import { ToastContainer } from 'react-toastify';
import ToastDismissAllButton from './ToastDismissAllButton';

const AppToastStack = () => {
	return (
		<div className="toast-stack-region">
			<ToastDismissAllButton />
			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick={false}
				closeButton={false}
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="light"
				aria-label='Notification Container'
			/>
		</div>
	);
};

export default AppToastStack;
